import { isGlobalFeatureEnabled } from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import getOutlookNewslettersAccessLevel from './getOutlookNewslettersAccessLevel';
import type OutlookNewslettersAccessLevels from 'owa-service/lib/contract/OutlookNewslettersAccessLevels';

export default function isOutlookNewslettersEnabled(): boolean {
    return (
        isGlobalFeatureEnabled('outlookNewsletters-enabled') &&
        getOutlookNewslettersAccessLevel() !== 3
    );
}
